import React from 'react';
import { Button } from './ui/Button';
const CALENDAR_URL = 'https://calendar.app.google/PYPdcRoYne7QrNJA7';
export function TheCure() {
  const phases = [{
    number: '1',
    title: 'DOMINACIÓN LOCAL DIGITAL',
    description: 'Posicionamos tu restaurante en el Top 3 de Google Maps y construimos reseñas masivas de 5 estrellas. Cuando alguien busca "restaurante mexicano en [tu ciudad]", apareces primero.'
  }, {
    number: '2',
    title: 'SISTEMA DE RESERVAS INTELIGENTE',
    description: 'Implementamos reservas online con confirmación automática. El cliente reserva desde su teléfono, recibe recordatorio 2 horas antes y tu restaurante elimina los no-show.'
  }, {
    number: '3',
    title: 'PROGRAMA DE FIDELIZACIÓN AUTOMÁTICO',
    description: 'Cada cliente que visita tu restaurante entra a un sistema de WhatsApp que le manda ofertas especiales en su cumpleaños, los días de semana y cuando lleva más de 30 días sin visitarte.'
  }];
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-24 px-4 border-b border-gray-900" data-id="element-236">
      <div className="max-w-4xl mx-auto" data-id="element-237">
        <div className="text-center mb-16" data-id="element-238">
          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-4" data-id="element-239">
            La Cura — Sistema A.C.E.™ Restaurante
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-240">
            Un proceso comprobado de 3 fases para transformar tu restaurante en
            una máquina predecible de reservas.
          </p>
        </div>

        <div className="space-y-8 mb-16" data-id="element-241">
          {phases.map((phase, index) => <div key={index} className="flex flex-col md:flex-row gap-6 md:gap-8 items-start bg-gray-900/20 border border-gray-800 p-8 rounded-sm" data-id="element-242">
              <div className="flex-shrink-0" data-id="element-243">
                <div className="w-12 h-12 bg-emerald/10 border border-emerald/30 text-emerald flex items-center justify-center text-xl font-bold rounded-sm" data-id="element-244">
                  {phase.number}
                </div>
              </div>
              <div data-id="element-245">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-246">
                  FASE {phase.number} —{' '}
                  <span className="text-gold" data-id="element-247">{phase.title}</span>
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed" data-id="element-248">
                  {phase.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex flex-col items-center" data-id="element-249">
          <Button onClick={scrollToContact} className="w-full md:w-auto" data-id="element-250">
            IMPLEMENTAR EL SISTEMA A.C.E.™
          </Button>
          <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="mt-4 text-sm text-gray-400 hover:text-gold transition-colors" data-id="element-251">
            O agenda directamente →
          </a>
        </div>
      </div>
    </section>;
}